var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EtsyListingsShopUser',{attrs:{"shopInfo":_vm.shopInfo,"shopId":_vm.shopId}})
}
var staticRenderFns = []

export { render, staticRenderFns }